import styled from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../styles/authShellMixins";

//PODE SER ESSE
export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%; 
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background: var(--app-bg-gradient);
  color: var(--text-primary);
  transition: background 180ms ease, color 180ms ease;

  ${mobileAuthMainContainer}
`;

/**
 * Área de conteúdo do shell. Altura fixa na viewport; o scroll
 * fica nos painéis filhos (perfil, edição, tabelas) com overflow-y: auto.
 */
export const SideContainer = styled.div`
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  max-height: 100vh;
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 5vw)" : "100%")};
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 

  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  align-items: stretch;
  justify-content: flex-start;

  overflow: hidden;

  ${mobileAuthSideContainer}
`;

export const SideContainerFlexStart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
